import axios from 'axios';
import { CountryDto, IndustryDto } from '../types/jobBoard';
import { JOBBOARD_API_BASE_URL } from './apiConfig';

const api = axios.create();
const API_BASE = `${JOBBOARD_API_BASE_URL}/api/lookups`;

export const lookupApi = {
  getIndustries: () => api.get<IndustryDto[]>(`${API_BASE}/industries`),
  getCountries: () => api.get<CountryDto[]>(`${API_BASE}/countries`),
};

export const LookupApi = lookupApi;